import { ConfigurationProperty } from '../model/configurationProperty';
import { NavigationCall } from '../model/navigationCall';
import { Intercom } from './intercom';
import { Topic } from './topic';
export class ServerApi {
    constructor() {
        this.configurationProperties = [];
        this.subscribeToActiveCaseModification = (topic, onReceiveCallback) => {
            this.intercom.subscribe(topic, (msg) => {
                onReceiveCallback(msg.payload);
            });
        };
        this.subscribeToRequestToRepublish = (onReceiveCallback) => {
            this.intercom.subscribe(Topic.REPUBLISH, (msg) => {
                onReceiveCallback(msg.payload, msg.originator || undefined);
            });
        };
        this.subscribeToDeletedCase = (onReceiveCallback) => {
            this.intercom.subscribe(Topic.DELETE_CASE, (msg) => {
                onReceiveCallback(msg.payload);
            });
        };
        this.unsubscribeFromAllSubscriptions = () => {
            for (const topic of Object.keys(Topic)) {
                this.intercom.unsubscribe(Topic[topic]);
            }
        };
        this.publishActiveCase = (activeCase, destination) => {
            this.intercom.publish(Topic.ACTIVE_CASE, activeCase, destination);
        };
        this.publishActiveUser = (user, destination) => {
            this.intercom.publish(Topic.ACTIVE_USER, user, destination);
        };
        this.publishOutletConfiguration = (outletConfiguration, destination) => {
            this.intercom.publish(Topic.OUTLET_CONFIGURATION, outletConfiguration, destination);
        };
        this.publishOidcToken = (oidcToken, destination) => {
            this.intercom.publish(Topic.OIDC_TOKEN, oidcToken, destination);
        };
        this.intercom = new Intercom("SERVER");
    }
    subscribeToOpenServiceCaseByVin(onReceiveCallback) {
        this.intercom.subscribe(Topic.OPEN_CASE_BY_VIN, (msg) => {
            onReceiveCallback(msg.payload);
        });
    }
    subscribeToNavigateTo(onReceiveCallback) {
        this.intercom.subscribe(Topic.NAVIGATE_TO, (msg) => {
            onReceiveCallback(NavigationCall.constructFromPlainObject(msg.payload));
        });
    }
    subscribeToClientInitializations(onReceiveCallback) {
        this.intercom.subscribe(Topic.CLIENT_INITIALIZATION, (msg) => {
            onReceiveCallback(msg.payload);
        });
    }
    unsubscribeFromClientInitializations() {
        this.intercom.unsubscribe(Topic.CLIENT_INITIALIZATION);
    }
    getConfigurationProperties() {
        return this.configurationProperties;
    }
    addConfigurationProperty(configurationProperty) {
        if (configurationProperty) {
            this.removeConfigurationProperty(configurationProperty.getKey(), configurationProperty.getDeclarer());
            this.configurationProperties.push(configurationProperty);
        }
    }
    removeConfigurationProperty(key, declarer) {
        this.configurationProperties = this.configurationProperties.filter((prop) => prop.getKey() !== key || prop.getDeclarer() !== declarer);
    }
    getConfigurationPropertyValue(key, declarer) {
        const prop = this.configurationProperties.find((p) => p.getKey() === key && p.getDeclarer() === declarer);
        if (prop) {
            return prop.getValue();
        }
        return undefined;
    }
    subscribeToConfigurationProperty(onReceiveCallback) {
        this.intercom.subscribe(Topic.CONFIGURATION_PROPERTY, (msg) => {
            this.addConfigurationProperty(ConfigurationProperty.constructFromPlainObject(msg.payload));
            onReceiveCallback();
        });
    }
    notifyError(msg) {
        this.intercom.publish(Topic.NOTIFY_ERROR, msg);
    }
    notifyInfo(msg) {
        this.intercom.publish(Topic.NOTIFY_INFO, msg);
    }
    notifySuccess(msg) {
        this.intercom.publish(Topic.NOTIFY_SUCCESS, msg);
    }
    notifyWarning(msg) {
        this.intercom.publish(Topic.NOTIFY_WARNING, msg);
    }
    subscribeToErrorNotifications(onReceiveCallback) {
        this.subscribeToNotification(onReceiveCallback, Topic.NOTIFY_ERROR);
    }
    subscribeToInfoNotifications(onReceiveCallback) {
        this.subscribeToNotification(onReceiveCallback, Topic.NOTIFY_INFO);
    }
    subscribeToSuccessNotifications(onReceiveCallback) {
        this.subscribeToNotification(onReceiveCallback, Topic.NOTIFY_SUCCESS);
    }
    subscribeToWarningNotifications(onReceiveCallback) {
        this.subscribeToNotification(onReceiveCallback, Topic.NOTIFY_WARNING);
    }
    subscribeToNotification(onReceiveCallback, topic) {
        this.intercom.subscribe(topic, (msg) => {
            onReceiveCallback(msg.payload);
        });
    }
}
//# sourceMappingURL=serverApi.js.map